import qs from 'qs'
import * as DataActions from '../actions/Data'
import { getJSON, postJSON } from '../common/services/api'
import { normalizeErrorMessage, showToast } from '../common/utils'

export function initialiseListData(role) {
  return (dispatch) => {
    dispatch(DataActions.clearAllLists())
    if (role === 'lmc-admin') return
    if (role === 'group-admin') {
      dispatch(loadLists(['homes']))
    } else {
      dispatch(
        loadLists([
          'carers',
          'homes',
          'residents',
          'log-categories',
          'log-category-items'
        ])
      )
    }
  }
}

// eslint-disable-next-line default-param-last
export function loadList(listId, query, overwrite = true, url) {
  return (dispatch) => {
    let targetUrl = url || `/api/list/${listId}`
    if (query) targetUrl += `?${qs.stringify(query)}`
    return getJSON({ url: targetUrl })
      .then((res) => {
        dispatch(DataActions.setLoadedList(listId, res.result, overwrite))
      })
      .catch((err) => {
        console.log(err)
        if (
          [
            'emar-round-timings',
            'emar-rounds',
            'emar-resident-medications'
          ].includes(listId)
        ) {
          showToast({ type: 'error', title: 'Something went wrong' })
        }
      })
  }
}

export function loadListItem(listId, itemId, query, url) {
  return (dispatch) => {
    let targetUrl = url || `/api/list/${listId}/${itemId}`
    if (query) targetUrl += `?${qs.stringify(query)}`
    return getJSON({ url: targetUrl })
      .then((res) => {
        dispatch(DataActions.setLoadedListItem(listId, res.result))
      })
      .catch((err) => {
        console.log(err)
      })
  }
}

export function createListItem({
  listId,
  itemId,
  json,
  successMsg,
  url,
  rethrow
}) {
  return (dispatch) =>
    postJSON({
      url: url || `list/${listId}/${itemId}`,
      method: 'POST',
      json
    })
      .then((res) => {
        if (successMsg) showToast({ title: successMsg })
        dispatch(DataActions.setLoadedListItem(listId, res.result))
        return res?.result || res
      })
      .catch((err) => {
        showToast({
          title: normalizeErrorMessage(err),
          type: 'error'
        })
        console.log(err)
        if (rethrow) {
          throw err
        }
      })
}

export function activatePin(pin) {
  return (dispatch) => {
    const url = `/api/set-pin`
    return postJSON({
      url,
      method: 'POST',
      pin
    })
      .then((res) => {
        if (successMsg) showToast({ title: successMsg })
        dispatch(DataActions.setLoadedListItem(listId, res.result))
        return res.result
      })
      .catch((err) => {
        showToast({
          title: 'Oops! Something went wrong!',
          type: 'error'
        })
        console.log(err)
      })
  }
}

export function updateListItem({ listId, itemId, json, successMsg, url }) {
  return (dispatch) =>
    postJSON({
      url: url || `list/${listId}/${itemId}`,
      method: 'PUT',
      json
    })
      .then((res) => {
        if (successMsg) showToast({ title: successMsg })
        dispatch(DataActions.setLoadedListItem(listId, res.result))
        return res.result
      })
      .catch((err) => {
        showToast({
          title: normalizeErrorMessage(err),
          type: 'error'
        })
        console.log(err)
      })
}

export function patchListItem({ listId, itemId, json, successMsg, url }) {
  return (dispatch) =>
    postJSON({
      url: url || `list/${listId}/${itemId}`,
      method: 'PATCH',
      json
    })
      .then((res) => {
        if (successMsg) showToast({ title: successMsg })
        dispatch(DataActions.setLoadedListItem(listId, res.result))
        return res.result
      })
      .catch((err) => {
        showToast({
          title: normalizeErrorMessage(err),
          type: 'error'
        })
        console.log(err)
      })
}

export function deleteListItem({ listId, itemId, json, successMsg, url }) {
  return (dispatch) =>
    postJSON({
      url: url || `list/${listId}/${itemId}`,
      method: 'DELETE',
      json
    })
      .then((res) => {
        if (successMsg) showToast({ title: successMsg })
        dispatch(DataActions.setLoadedListItem(listId, res.result))
        return res.result || res.success
      })
      .catch((err) => {
        showToast({
          title: 'Oops! Something went wrong!',
          type: 'error'
        })
        console.log(err)
      })
}

export function loadLists(lists) {
  const urls = lists.map((listId) => `/api/list/${listId}`)
  return (dispatch) => {
    Promise.all(urls.map((url) => getJSON({ url })))
      .then((results) => {
        results.forEach((list, index) => {
          list.listId = lists[index]
        })
        dispatch(DataActions.setLoadedLists(results))
      })
      .catch((err) => {
        console.log(err)
      })
  }
}

export function fetchData({ url, query, id }) {
  return (dispatch) => {
    // I didn't choose to do that, I am sorry for the mess.
    const isEmarUrl = url.startsWith('/emar') || url.startsWith('emar')
    let targetUrl = isEmarUrl ? url : `/api/${url}`
    if (query) targetUrl += `?${qs.stringify(query)}`
    dispatch(DataActions.initDataFetch(id))
    return getJSON({ url: targetUrl })
      .then((response) => {
        dispatch(DataActions.setDataFetchResponse(id, response))
      })
      .catch((error) =>
        dispatch(DataActions.setDataFetchError(id, error.message))
      )
  }
}
